export const capitalizeString = (text: string) => {
  const capitalizedString = text.charAt(0).toUpperCase() + text.slice(1);

  return capitalizedString;
};
